import React, { useEffect, useRef, useState } from "react";
import Loader from "../../components/Loader";
import { notifyError, notifySuccess } from "../../components/NotifyToast";
import QRCode from "react-qr-code";
import * as apiAppointment from '../../services/ApiAppointment'

import { Box, Typography, Button, TextField, Tooltip, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import backIcon from '../../assets/icons/backicon.svg'
import { useSelector } from "react-redux";

import { IoArrowBackOutline } from "react-icons/io5";

import { config } from '../../config.env';

import dayjs from "dayjs";
import 'dayjs/locale/th';
import buddhistEra from "dayjs/plugin/buddhistEra";
dayjs.extend(buddhistEra);

function DateLongTH() {
    dayjs.locale("th");
    return dayjs().format("dddd D MMMM BBBB");
}

function durationFormat(ms,HRS=' ชม.',MINS=' นาที',SECS=' วินาที')
{
    let secs = Math.ceil(ms/1000);
    const hours = Math.floor(secs / 3600);
    secs -= hours*3600;
    const mins = Math.floor(secs / 60);
    secs -= mins*60;

    let out = '';
    if (hours > 0)
        out += `${hours}${HRS}`;
    if (mins > 0)
        out += `${out ? ' ' : ''}${mins}${MINS}`;
    if (secs > 0)
        out += `${out ? ' ' : ''}${secs}${SECS}`;

    return out;
}

export default function Consult() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const userData = useSelector((state) => state.auth.user_data)

    const [currentTime, setCurrentTime] = useState(dayjs().format('HH:mm:ss'));
    const name = useRef(userData['fname'] + ' ' + userData['lname']);
    const [nextApm, setNextApm] = useState(null);
    const countdown = useRef(undefined);
    const [confURL, setConfURL] = useState('');

    useEffect(() => {
        getConferrenceRoom()
    },[]);

    useEffect(() => {

        const timer = setInterval(() => {

            setCurrentTime(dayjs().format('HH:mm:ss'));
            countdown.current = nextApm ? nextApm['appointment_timestamp'] - Date.now() : undefined;
            
        }, 1000);

        return () => clearInterval(timer);

    }, [nextApm])

    const getConferrenceRoom = async () => {

        setLoading(true);

        setNextApm(null);
        setConfURL('');

        const now = Date.now();
        const today = dayjs().format('YYYY-MM-DD');
        let res = await apiAppointment.appointmentList(today,today);

        setLoading(false);

        // MockUp
        if ((!res || res['data']['code'] !== 200) && !config.PRODUCTION)
        {
            console.log("Mockup Telemed");
            res = {
                data: {
                    code: 200,
                    data: [
                        {
                            appointment_status: 'C',
                            appointment_date: today,
                            appointment_time: dayjs(now + 305000).format('HH:mm:ss'),
                            hospital_code: '00000',
                            hospital_name: 'รพ.ทดสอบ',
                            department_name: 'แผนกทดสอบ',
                            doctor_name: 'หมอยังไม่พร้อม',
                            conference: {
                                conference_url: "https://vcr.omnix365.world/"
                            }
                        }
                    ]
                }
            };
        }

        if (res)
        {
            if (res['data']['code'] === 200)
            {
                const data = res['data']['data'];
                const dataN = data.length;

                let closestApm = null;
                let closestTimeDiff = 31536000000;

                for (let i=0; i<dataN; i++)
                {
                    const apm = data[i];
                    if (!apm || !apm.conference?.conference_url)
                        continue;
                    
                    const apmTime = +(new Date(`${apm.appointment_date}T${apm.appointment_time}`));
                    const timeDiff = (now - apmTime)/60000;

                    // Within 5 mins before or 30 mins after appointment time
                    if (timeDiff >= -5 && timeDiff <= 30)
                    {
                        apm['appointment_timestamp'] = apmTime;
                        closestApm = apm;
                        break;
                    }

                    if (timeDiff <= closestTimeDiff)
                    {
                        apm['appointment_timestamp'] = apmTime;
                        closestTimeDiff = timeDiff;
                        closestApm = apm;
                    }
                }

                setNextApm(closestApm);
                setConfURL(closestApm.conference.conference_url);
            }
            else notifyError(res['data']['message']);
        }
        else notifyError('ไม่ตอบสนอง');
    }

    const checkApmStatus = async () => {

        if (!nextApm)
        {
            notifyError('ไม่พบการนัดหมาย');
            return false;
        }

        setLoading(true);

        const today = dayjs().format('YYYY-MM-DD');
        let res = await apiAppointment.appointmentList(today,today);
        setLoading(false);

        if (res)
        {
            if (res['data']['code'] === 200)
            {
                const data = res['data']['data'];
                const dataN = data.length;

                for (let i=0; i<dataN; i++)
                {
                    const apm = data[i];
                    if (apm.appointment_number !== nextApm.appointment_number)
                        continue;

                    console.log(apm);
                    if (apm.appointment_status !== "W")
                    {
                        getConferrenceRoom();
                        return false;
                    }
                    return true;
                }
            }
            else notifyError(res['data']['message']);
        }
        else notifyError('ไม่ตอบสนอง');
    }

    const clickJoinConferrence = async (url) => {

        if (await checkApmStatus())
            window.open(url, "_system");
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }

        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (
        <>
            <Loader loading={loading} />
            
            <Box sx={{
                color: '#263238',
                display: 'flex',
                flexDirection: 'column',
                gridGap: 20,
                fontSize: 18,
                margin: { xl: '2rem', lg: '2rem', md: '2rem', sm: '2rem', xs: '2rem 1rem' },
                '@media (max-width: 1023px)': {
                    gridGap: '3%',
                    fontSize: 16,
                },
                '@media (max-width: 800px)': {
                    gridGap: '1%',
                    fontSize: 14,
                },
                '@media (orientation: portrait)': {
                    fontSize: '6vw',
                }
            }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    mb:2,
                    '@media (orientation: portrait)': {
                        gridTemplateColumns: '1fr 3fr 1fr',
                        '@media (min-width: 1000px)': {
                            m: '1em',
                        },
                    }
                }}>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'start',
                        ml: '3rem',
                        '@media (orientation: portrait)': {
                            ml: 0,
                        }
                    }}>
                        <Tooltip title="ย้อนกลับ">
                            <IconButton onClick={() => { navigate('/mainMenu') }} aria-label="Back" color="c_button" variant="resp">
                                <IoArrowBackOutline size='1.25em'/>
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box sx={{
                        textAlign: 'center',
                        alignSelf: 'end',
                        color: 'c_title.main',
                        '@media (orientation: portrait)': {
                            alignSelf: 'center',
                        }
                    }}
                    >ปรึกษา</Box>

                </Box>

                <Box sx={{
                    width: 500,
                    margin: 'auto',
                    border: '1px solid #E1E3E9',
                    borderRadius: '15px',
                    background: '#FFFFFF',
                    padding: 1,
                    '@media (orientation: portrait)': {
                        width: '80vw',
                        '@media (min-width: 1000px)': {
                            padding: 2,
                        },
                    },
                }}>
                    <Box sx={{
                        borderRadius: '15px',
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: 'center',
                        width: '100%',
                        height: 'auto',
                    }}>
                        <div style={{
                            border: '1px solid #E1E3E9',
                            borderRadius: '15px',
                        }}>
                            <Box sx={{
                                borderRadius: '15px 15px 0px 0px',
                                backgroundColor: '#E3E9F2',
                                fontSize: '1em'
                                //width: '100%'
                            }} >
                                <div style={{
                                    padding: '1em'
                                }}>
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize:'1.25em'
                                        }}
                                        align='center'
                                    >
                                        {currentTime}
                                    </Typography>
                                    <Typography variant="body2" align='center' fontSize='0.6em'>
                                        วัน {DateLongTH()}
                                    </Typography>
                                </div>
                            </Box>

                            <div style={{ padding: '1rem' }}>
                                <div style={{ padding: '0.6em 0.5em 0.6em 0.5em', fontSize: '0.6em' }}>
                                    <Typography sx={{ fontSize: '1em', mb: '0.25em', fontWeight: 'bold' }}>
                                        ชื่อผู้ใช้งาน
                                    </Typography>
                                    <TextField
                                        inputProps={
                                            {
                                                readOnly: true,
                                                sx: { 
                                                    '@media (orientation: portrait)': {
                                                        '@media (min-width: 1000px)': {
                                                            fontSize: '2.4em' 
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        sx={{ width: '100%'}}
                                        value={name.current}
                                    />
                                    <Typography sx={{ fontSize: '1em', mb: '0.25em', mt: '1em', fontWeight: 'bold' }}>
                                        ชื่อแพทย์
                                    </Typography>
                                    <TextField
                                        inputProps={
                                            {
                                                readOnly: true,
                                                sx: { 
                                                    '@media (orientation: portrait)': {
                                                        '@media (min-width: 1000px)': {
                                                            fontSize: '2.4em' 
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        sx={{ width: '100%'}}
                                        value={nextApm?.['doctor_name'] ? nextApm['doctor_name'] : '-'}
                                    />
                                    { nextApm ?
                                        <Box sx={{display:'flex', flexDirection:'column', pl:'0.5em', pt:'1em', gap:'0.5em', color: '#000', fontWeight: 500}}>
                                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr'}}>
                                                <div>
                                                    <Box sx={{ color: '#082C91', fontWeight: 700 }}>โรงพยาบาล</Box>
                                                    <Box sx={{pl:'0.5em'}}>{nextApm['hospital_name']}</Box>
                                                </div>
                                                <div>
                                                    <Box sx={{ color: '#082C91', fontWeight: 700 }}>แผนก</Box>
                                                    <Box sx={{pl:'0.5em'}}>{nextApm['department_name']}</Box>
                                                </div>
                                            </div>
                                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr'}}>
                                                <div>
                                                    <Box sx={{ color: '#082C91', fontWeight: 700}}>วันที่นัดหมาย</Box>
                                                    <Box sx={{pl:'0.5em'}}>{convertDate(nextApm['appointment_date'])}</Box>
                                                </div>
                                                <div>
                                                    <Box sx={{ color: '#082C91', fontWeight: 700 }}>เวลานัดหมาย</Box>
                                                    <Box sx={{pl:'0.5em'}}>{nextApm['appointment_time']}</Box>
                                                </div>
                                            </div>
                                        </Box>
                                        :
                                        <></>
                                    }
                                </div>
                                <div style={{margin: '0.25em 0px 0.25em'}}>
                                    <Button
                                        sx={{ width: '100%', height: '2.5em', fontSize: '0.6em' }}
                                        color='c_yellow'
                                        variant="contained"
                                        disabled={(confURL && nextApm?.appointment_status === "W" && countdown.current && countdown.current <= 300000 && countdown.current >= -1800000) ? null : true}
                                        onClick={() => { clickJoinConferrence(confURL) }}
                                
                                    >{countdown.current && countdown.current > 300000 ? `ถึงเวลานัดหมายใน ${durationFormat(countdown.current)}` : "เข้าร่วม Telemed ปรึกษาออนไลน์"}</Button>
                                </div>

                            </div>
                        </div>
                    </Box>
                </Box>
            </Box>
        </>
    )
}